import { PAGE_ROUTES } from '~/constants/pages';
import { trackEvent } from './tracking';

interface ValidateStoreVariablesProps {
  url: string;
  address?: string;
  selectedProductId?: string;
}

const addressRequiredRoutes = [PAGE_ROUTES.PLAN_PACKAGE, PAGE_ROUTES.RECOMMENDATION, PAGE_ROUTES.BUILD];

const productRequiredRoutes = [
  PAGE_ROUTES.INSTALLATION,
  PAGE_ROUTES.CHECKOUT,
  PAGE_ROUTES.CONTACT_CREDIT,
  PAGE_ROUTES.BILLING_SUMMARY,
];

const trackError = (message: string) => {
  trackEvent({
    action: 'clientErrored',
    data: { errorMessage: message, errorClass: 'ERROR' },
  });
};

export function validateStoreVariables({ url, address, selectedProductId }: ValidateStoreVariablesProps): void {
  if (addressRequiredRoutes.some((route) => url.includes(route)) && !address) {
    trackError('Missing address for plan package');
  }

  if (productRequiredRoutes.some((route) => url.includes(route)) && !selectedProductId) {
    trackError('Missing product selection');
  }
}
